// ************************************************************************************************************************************************************
//
// CONFIDENTIAL
// Unpublished Work, Copyright 2023, Baxter Healthcare Corporation. All rights reserved.
// For use only by Baxter Healthcare Corporation.
// This document contains proprietary information. It must not be reproduced
// or disclosed to others without prior written approval.
//
// Filename: Users.js
// Description: This file is responsible to show user Grid
//
// ************************************************************************************************************************************************************
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "../redux/action";
import {
  getUser,
  searchUsers,
  getUserforFacility,
  deleteUser,
  deleteSearchUser,
} from "./_redux/userCrud";
import AddUserPage from "./pages/AddUserPage";
import { withRouter } from "react-router";
import { Checkbox, Tooltip } from "@material-ui/core";
import Usersvg from "../../../icons/Usersvg.svg";
import Refresh from "../../../icons/Refresh.svg";
import DownArrow from "../../../icons/DownArrow.svg";
import EditSvg from "../../../icons/EditSvg.svg";
import { withStyles } from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";
import { RecordsperPage } from "../../../Application_Constants";
import {
  MenuType,
  DeletePopupMsg,
  SortOrder,
  UserColumns,
} from "../../../Application_Constants";
import DeletePage from "../Monitors/pages/DeletePage";
import { Divider } from "@material-ui/core";

class Users extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      error: false,
      deletePopupError: false,
      loading: false,
      deleteLoader: false,
      modalShow: false,
      isEdit: false,
      editId: null,
      facilities: null,
      paginationLoading: false,
      isAscending: false,
      currentPage: 1,
      totalCount: 0,
      checkedArray: [],
      skipedArray: [],
      isAllSelected: false,
      partiallySelected: false,
      deleteModalShow: false,
      deleteMsg: DeletePopupMsg.emptyMsg,
      sort_order: SortOrder.DESCENDING,
      sortedColumn: UserColumns.CREATED_DATE,
      toshowokbtn: true,
      deletefacility_id: null,
    };
    this.handleSort = this.handleSort.bind(this);
  }
  componentDidMount() {
    this.fetchUsers();
    this.props.UserListRefresh(false);
  }

  handlePageChange = (event, value) => {
    this.setState({
      ...this.state,
      currentPage: value,
    });
    setTimeout(() => {
      this.fetchUsers();
    }, 0);
  };

  handleSort = (columnName) => {
    const { sortedColumn, sort_order } = this.state;
    const newSortBy =
      columnName === sortedColumn
        ? sort_order === SortOrder.ASCENDING
          ? SortOrder.DESCENDING
          : SortOrder.ASCENDING
        : SortOrder.ASCENDING;
    this.setState(
      {
        sort_order: newSortBy,
        sortedColumn: columnName,
      },
      () => {
        this.fetchUsers();
      }
    );
  };

  fetchUsers() {
    setTimeout(() => {
      if (this.props.searchUser.length === 0) {
        switch (this.props.selectedMenu) {
          case MenuType.USER_ALL:
          case MenuType.USER_ACTIVE:
          case MenuType.USER_INACTIVE:
            this.usersList();
            this.props.searchBarChange(true);
            break;
          default:
            this.userByFacility();
            break;
        }
      } else {
        this.onSearchUser();
      }
    }, 0);
  }

  refreshUserGrid = () => {
    if (this.props.searchUser.length !== 0) {
      this.onSearchUser();
      this.setState({
        ...this.state,
        loading: true,
      });
    } else {
      this.fetchUsers();
      this.props.refreshUsercount(true);
    }
  };

  componentDidUpdate(prevProps, prevState) {
    setTimeout(() => {
      if (
        this.props.selectedMenu !== prevProps.selectedMenu ||
        this.props.searchUser !== prevProps.searchUser
      ) {
        this.setState({
          ...this.state,
          currentPage: 1,
          checkedArray: [],
          skipedArray: [],
          isAllSelected: false,
          partiallySelected: false,
          sort_order: SortOrder.DESCENDING,
          sortedColumn: UserColumns.CREATED_DATE,
        });
        this.fetchUsers();
      }
      // To refresh the grid on add user popup close
      if (
        this.props.userListRefresh !== prevProps.userListRefresh &&
        this.props.userListRefresh === true
      ) {
        this.props.UserListRefresh(false);
        this.fetchUsers();
      }
      if (
        this.props.isDelete !== prevProps.isDelete &&
        this.props.isDelete === true
      ) {
        this.props.handleDelete(false);
        setTimeout(() => {
          this.initializeDeletePopup();
          this.setState({
            ...this.state,
            deleteModalShow: true,
          });
        }, 0);
      }
    }, 0);
  }

  onSearchUser = () => {
    if (this.props.searchUser) {
      if (this.state.currentPage !== 0) {
        this.setState({ ...this.state, loading: true, users: [] });
      } else {
        this.setState({ ...this.state, paginationLoading: true });
      }
      //use this if you want the user to be displayed by facility
      /*let facility_id =
        this.props.selectedMenu === "all" ? "all" : this.props.selectedMenu.id;*/

      //  let facility_id = "all"

      this.setState({
        ...this.state,
        search: this.props.searchUser,
      });

      searchUsers({
        searchValue: this.props.searchUser,
        facilityId: this.props.selectedMenu,
        count: RecordsperPage,
        page: this.state.currentPage,
        sort_column: this.state.sortedColumn,
        sort_order: this.state.sort_order,
      })
        .then((response) => {
          const { data, status, message, count } = response.data;
          if (status) {
            this.setState(
              {
                ...this.state,
                users: data,
                loading: false,
                error: false,
                totalCount: count,
              },
              () => {
                this.pageChangeCBSelect();
              }
            );
          } else {
            this.setState({
              ...this.state,
              error: message,
              loading: false,
              paginationLoading: false,
              totalCount: 0,
            });
          }
        })
        .catch((error) => {
          this.setState({
            ...this.state,
            loading: false,
            error: error.message,
            paginationLoading: false,
            totalCount: 0,
          });
        });
    }
  };

  usersList = () => {
    this.props.FacilityName("");
    this.props.monitorDetails(false);
    if (this.state.currentPage !== 0) {
      this.setState({ ...this.state, loading: true, users: [] });
    } else {
      this.setState({ ...this.state, paginationLoading: true });
    }
    getUser({
      count: RecordsperPage,
      page: this.state.currentPage,
      sort_column: this.state.sortedColumn,
      sort_order: this.state.sort_order,
      user_menu: this.props.selectedMenu,
    })
      .then((res) => {
        const { data, status, message, count } = res.data;
        if (status) {
          this.setState(
            {
              ...this.state,
              users: data,
              loading: false,
              error: false,
              totalCount: count,
            },
            () => {
              this.pageChangeCBSelect();
            }
          );
        } else {
          this.setState({
            ...this.state,
            error: message,
            loading: false,
            paginationLoading: false,
            totalCount: 0,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status !== 404 && error) {
            this.setState({
              ...this.state,
              loading: false,
              error: error.response.data.message,
              paginationLoading: false,
              totalCount: 0,
            });
          } else {
            this.props.history.push("error/error-v1");
          }
        } else {
          this.setState({
            ...this.state,
            loading: false,
            error: error.message,
            paginationLoading: false,
            totalCount: 0,
          });
        }
      });
  };

  userByFacility = () => {
    if (this.state.currentPage !== 0) {
      this.setState({ ...this.state, loading: true, users: [] });
    } else {
      this.setState({ ...this.state, paginationLoading: true });
    }

    getUserforFacility(
      this.props.facility_user,
      RecordsperPage,
      this.state.currentPage,
      this.state.sortedColumn,
      this.state.sort_order
    )
      .then((res) => {
        const { data, status, message, count } = res.data;

        if (status) {
          this.setState(
            {
              ...this.state,
              users: data,
              loading: false,
              error: false,
              totalCount: count,
            },
            () => {
              this.pageChangeCBSelect();
            }
          );
        } else {
          this.setState({
            ...this.state,
            error: message,
            loading: false,
            paginationLoading: false,
            totalCount: 0,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status !== 404 && error) {
            this.setState({
              ...this.state,
              loading: false,
              error: error.response.data.message,
              paginationLoading: false,
              totalCount: 0,
            });
          } else {
            this.props.history.push("error/error-v1");
          }
        } else {
          this.setState({
            ...this.state,
            loading: false,
            error: error.message,
            paginationLoading: false,
            totalCount: 0,
          });
        }
      });
  };

  editUser = (id) => {
    this.setState({
      ...this.state,
      editId: id,
      isEdit: true,
      modalShow: true,
    });
  };

  modalClose = (opt) => {
    this.setState({
      ...this.state,
      modalShow: false,
      isEdit: false,
    });
    if (opt === "add") {
      this.fetchUsers();
      this.props.refreshUsercount(true);
    }
  };

  selectAll() {
    const hasToCheckAll = !this.state.isAllSelected;
     this.state.users.map((item) => {
      item.checked = hasToCheckAll;
      return item;
    });
    this.setState({
      ...this.state,
      partiallySelected: false,
      isAllSelected: !this.state.isAllSelected,
      checkedArray: [],
      skipedArray: [],
    });
  }

  handleSingleSelect = (clickedItem) => {
    clickedItem.checked = !clickedItem.checked;
    if (this.state.isAllSelected) {
      if (clickedItem.checked === true) {
        const skipedArrayindex = this.state.skipedArray.indexOf(
          clickedItem.user_id
        );
        if (skipedArrayindex > -1) {
          this.state.skipedArray.splice(skipedArrayindex, 1);
        }
      } else {
        this.state.skipedArray.push(clickedItem.user_id);
      }
    } else {
      if (clickedItem.checked === true) {
        this.setState({
          ...this.state,
          partiallySelected: true,
        });
        this.state.checkedArray.push(clickedItem.user_id);
      } else {
        const checkedArrayindex = this.state.checkedArray.indexOf(
          clickedItem.user_id
        );
        if (checkedArrayindex > -1) {
          this.state.checkedArray.splice(checkedArrayindex, 1);
        }
      }
    }

    if (this.state.totalCount === this.state.checkedArray.length.toString()) {
      this.setState({
        ...this.state,
        partiallySelected: false,
        isAllSelected: true,
        checkedArray: [],
        skipedArray: [],
      });
    } else if (
      this.state.totalCount === this.state.skipedArray.length.toString()
    ) {
      this.setState({
        ...this.state,
        partiallySelected: false,
        isAllSelected: false,
        checkedArray: [],
        skipedArray: [],
      });
    } else if (
      this.state.skipedArray.length === 0 &&
      this.state.checkedArray.length === 0
    ) {
      this.setState({
        ...this.state,
        partiallySelected: false,
        isAllSelected: this.state.isAllSelected,
      });
    } else {
      this.setState({
        ...this.state,
        partiallySelected: true,
      });
    }
  };

  pageChangeCBSelect() {
    const tempDate = this.state.users;
    if (this.state.isAllSelected) {
      tempDate.forEach((item) => {
        if (this.state.skipedArray.includes(item.user_id)) {
          item.checked = false;
        } else {
          item.checked = this.state.isAllSelected;
        }
      });
    } else {
      tempDate.forEach((item) => {
        if (this.state.checkedArray.includes(item.user_id)) {
          item.checked = true;
        }
      });
    }
    this.setState({
      ...this.state,
      users: tempDate,
    });
  }

  deletemodalClose = (opt) => {
    if (opt === "cancel" || opt === "ok") {
      this.setState({
        ...this.state,
        deleteModalShow: false,
        deletePopupError: "",
      });
    } else if (opt === "continue") {
      this.deletedUserApiCall(true);
    }
  };

  initializeDeletePopup() {
    if (this.state.isAllSelected || this.state.checkedArray.length > 0) {
      this.deletedUserApiCall(false);
      this.setState({
        ...this.state,
        toshowokbtn: false,
      });
    } else {
      this.setState({
        ...this.state,
        deleteMsg: DeletePopupMsg.emptyMsg,
        toshowokbtn: true,
      });
    }
  }

  deletedUserApiCall(isForceDelete) {
    this.setState({ ...this.state, deleteLoader: true });
    if (this.props.searchUser && this.props.searchUser.length !== 0) {
      deleteSearchUser(
        this.props.selectedMenu,
        this.props.facility_user,
        isForceDelete,
        this.props.searchUser,
        this.state.checkedArray,
        this.state.skipedArray
      )
        .then((res) => {
          const { message } = res;
          if (res.status) {
            this.resetValues();
            this.fetchUsers();
            this.props.refreshUsercount(true);
            this.setState({
              ...this.state,
              deleteLoader: false,
              deletePopupError: false,
              deleteModalShow: false,
            });
          } else {
            this.setState({
              ...this.state,
              deletePopupError: message,
              deleteLoader: false,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            if (
              error.response.status !== 404 &&
              error.response.status !== 954 &&
              error.response.status !== 953 &&
              error
            ) {
              this.setState({
                ...this.state,
                deleteLoader: false,
                deletePopupError: error.response.data.message,
              });
            }
            if (error.response.status === 954 && error) {
              this.setState({
                ...this.state,
                deleteLoader: false,
                deleteMsg: DeletePopupMsg.UserFacilityAssociations,
              });
            } else if (error.response.status === 953 && error) {
              this.setState({
                ...this.state,
                deleteLoader: false,
                deleteMsg: DeletePopupMsg.deleteRecord,
              });
            } else {
              this.props.history.push("error/error-v1");
            }
          } else {
            this.setState({
              ...this.state,
              deleteLoader: false,
              deletePopupError: error.message,
            });
          }
        });
    } else {
      const usermenu = this.props.facility_user ? "" : this.props.selectedMenu;
      deleteUser(
        usermenu,
        this.props.facility_user,
        isForceDelete,
        this.state.checkedArray,
        this.state.skipedArray
      )
        .then((res) => {
          const { message } = res;
          if (res.status) {
            this.resetValues();
            this.fetchUsers();
            this.props.refreshUsercount(true);
            this.setState({
              ...this.state,
              deleteLoader: false,
              deletePopupError: false,
              deleteModalShow: false,
            });
          } else {
            this.setState({
              ...this.state,
              deletePopupError: message,
              deleteLoader: false,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            if (
              error.response.status !== 404 &&
              error.response.status !== 954 &&
              error.response.status !== 953 &&
              error
            ) {
              this.setState({
                ...this.state,
                deleteLoader: false,
                deletePopupError: error.response.data.message,
              });
            }
            if (error.response.status === 954 && error) {
              this.setState({
                ...this.state,
                deleteLoader: false,
                deleteMsg: DeletePopupMsg.UserFacilityAssociations,
              });
            } else if (error.response.status === 953 && error) {
              this.setState({
                ...this.state,
                deleteLoader: false,
                deleteMsg: DeletePopupMsg.deleteRecord,
              });
            } else {
              this.props.history.push("error/error-v1");
            }
          } else {
            this.setState({
              ...this.state,
              deleteLoader: false,
              deletePopupError: error.message,
            });
          }
        });
    }
  }

  resetValues() {
    this.setState({
      ...this.state,
      checkedArray: [],
      skipedArray: [],
      isAllSelected: false,
      partiallySelected: false,
      deleteMsg: DeletePopupMsg.emptyMsg,
      toshowokbtn: true,
      currentPage: 1,
    });
  }

  render() {
    const {
      users,
      loading,
      error,
      currentPage,
      sortedColumn,
      sort_order,
      totalCount,
      deleteModalShow,
      deleteMsg,
      toshowokbtn,
      deletePopupError,
      deleteLoader,
      isAllSelected,
      partiallySelected,
      paginationLoading,
      facilities,
      isEdit,
      editId,
      modalShow,
    } = this.state;
  
    const totalPages = Math.ceil(totalCount / RecordsperPage);

    const LightTooltip = withStyles((theme) => ({
      tooltip: {
        boxShadow: theme.shadows[1],
        fontSize: 11,
        padding: "8px",
      },
    }))(Tooltip);

    return (
      <>
        <button
          className={
            this.props.selectedMenu !== MenuType.USER_INACTIVE &&
            this.props.selectedMenu !== MenuType.USER_ALL
              ? "button-refresh-monitorGrid-addmargin"
              : "button-refresh-monitorGrid"
          }
          onClick={this.refreshUserGrid}
        >
          <img className="imgCloud" src={Refresh} alt="Refresh"></img>
          <span className="imgCloudSpan">Refresh</span>
        </button>
        <h1 className="text-Heading">
          <img src={Usersvg} alt="Usersvg" style={{ marginLeft: "7px" }}></img>
          {this.props.selectedMenu === MenuType.USER_INACTIVE ? (
            <span>Inactive Users</span>
          ) : this.props.selectedMenu === MenuType.USER_ACTIVE ? (
            <span>Active Users</span>
          ) : (
            <span>All Users</span>
          )}
        </h1>
        <Divider></Divider>
        <div>
          <div
            className="tableFixHead Usergrid"
            onScroll={!paginationLoading ? this.pagination : null}            
          >
            <table
              className="table table-hover table-striped table-hover align-middle "
              style={{ marginBottom: "0" }}
            >
              <thead>
                <tr>
                  <th style={{ width: "10px" }}>
                    <Checkbox
                      style={{ marginLeft: "40px" }}
                      disabled={totalCount === 0}
                      checked={isAllSelected}
                      indeterminate={partiallySelected}
                      onChange={(e) => this.selectAll()}
                    ></Checkbox>
                  </th>
                  <th style={{ width: "61px" }}></th>

                  <th
                    style={{
                      width: "321px",
                      cursor: "pointer",
                    }}
                    onClick={() => this.handleSort(UserColumns.USERNAME)}
                  >
                    User Name{" "}
                    {sortedColumn === UserColumns.USERNAME &&
                      (sort_order === SortOrder.ASCENDING ? (
                        <img
                          className="imgdesc"
                          style={{
                            paddingRight: "20px",
                          }}
                          src={DownArrow}
                          alt="DownArrow"
                        ></img>
                      ) : (
                        <img
                          className="imgasc"
                          style={{ paddingLeft: "20px" }}
                          src={DownArrow}
                          alt="DownArrow"
                        ></img>
                      ))}
                  </th>
                  <th
                    style={{
                      paddingLeft: "40px",
                      width: "321px",
                    }}
                    scope="col"
                  >
                    Facility
                  </th>
                  <th
                    style={{
                      width: "321px",
                      paddingLeft: "30px",
                    }}
                  >
                    Facility ID
                  </th>
                  <th
                    style={{
                      paddingLeft: "26px",
                      cursor: "pointer",
                      width: "278px",
                    }}
                    onClick={() => this.handleSort(UserColumns.PHONE_NUMBER)}
                  >
                    Phone{" "}
                    {sortedColumn === UserColumns.PHONE_NUMBER &&
                      (sort_order === SortOrder.ASCENDING ? (
                        <img
                          className="imgdesc"
                          style={{ paddingRight: "15px" }}
                          src={DownArrow}
                          alt="DownArrow"
                        ></img>
                      ) : (
                        <img
                          style={{ paddingLeft: "15px", paddingBottom: "4px" }}
                          src={DownArrow}
                          alt="DownArrow"
                        ></img>
                      ))}
                  </th>
                  <th
                    style={{
                      paddingLeft: "10px",
                      textAlign: "right",
                      paddingRight: "45px",
                    }}
                  >
                    Edit
                  </th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="12" align="center">
                      <div class="d-flex justify-content-center">
                        <span
                          style={{ justifyContent: "center" }}
                          className="ml-3 spinner spinner-dark "
                        ></span>
                      </div>
                    </td>
                  </tr>
                ) : (
                  users &&
                  users.map((value, index) => (
                    <tr key={index.toString()}>
                      <td style={{ width: "10px" }}>                      
                        <Checkbox
                          style={{ marginLeft: "40px" }}
                          checked={value.checked}
                          onChange={(e) => this.handleSingleSelect(value)}
                        ></Checkbox>
                      </td>
                      <td style={{ width: "5px" }}>
                        <img
                          style={{
                            marginTop: "15px",
                            marginBottom: "12px",
                            marginRight: "13px",
                          }}
                          src={Usersvg}
                          alt="Usersvg"
                        ></img>
                      </td>

                      <LightTooltip
                        PopperProps={{ style: { marginTop: "-25px" } }}
                        disableHoverListener={
                          !value.first_name && !value.last_name
                        }
                        title=<span style={{ fontSize: "12px" }}>
                          {value.last_name} {value.first_name}{" "}
                        </span>
                      >
                        <td
                          style={{
                            margin: 0,
                            width: "321px",
                            fontWeight: "500",
                            fontSize: "16px",
                            color: "#313233",
                            maxWidth: "180px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {value.last_name} {value.first_name}{" "}
                        </td>
                      </LightTooltip>

                      <td
                        style={{
                          margin: 0,
                          width: "321px",
                          fontWeight: "500",
                          fontSize: "16px",
                          color: "#313233",
                          maxWidth: "180px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {value.assigned_facilities.length !== 0 ? (
                          <div
                            style={{
                              margin: 0,

                              fontWeight: "500",
                              fontSize: "16px",
                              color: "#313233",

                              paddingLeft: "30px",
                            }}
                          >
                            {value.assigned_facilities &&
                              value.assigned_facilities.map((facilities) => {
                                return (
                                  <LightTooltip
                                    PopperProps={{
                                      style: { marginTop: "-25px" },
                                    }}
                                    title=<span style={{ fontSize: "12px" }}>
                                      {facilities.name}{" "}
                                    </span>
                                  >
                                    <div
                                      style={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                      key={facilities.id}
                                    >
                                      {facilities.name}
                                    </div>
                                  </LightTooltip>
                                );
                              })}
                          </div>
                        ) : (
                          <p
                            style={{
                              margin: 0,

                              fontWeight: "500",
                              fontSize: "16px",
                              color: "#313233",

                              paddingLeft: "30px",
                            }}
                          >
                            ---
                          </p>
                        )}
                      </td>

                      <td
                        style={{
                          margin: 0,
                          width: "321px",
                          fontWeight: "500",
                          fontSize: "16px",
                          color: "#313233",
                          maxWidth: "180px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {value.assigned_facilities.length !== 0 ? (
                          <div
                            style={{
                              margin: 0,

                              fontWeight: "500",
                              fontSize: "16px",
                              color: "#313233",
                            }}
                          >
                            {value.assigned_facilities &&
                              value.assigned_facilities.map((facilities) => {
                                return (
                                  <LightTooltip
                                    title=<span style={{ fontSize: "12px" }}>
                                      {" "}
                                      {facilities.facility_id}
                                    </span>
                                  >
                                    <div
                                      colSpan={2}
                                      style={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        paddingLeft: "22px",
                                      }}
                                      key={facilities.id}
                                    >
                                      {facilities.facility_id}
                                    </div>
                                  </LightTooltip>
                                );
                              })}
                          </div>
                        ) : (
                          <div
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              paddingLeft: "22px",
                            }}
                          >
                            ---
                          </div>
                        )}
                      </td>

                      <td
                        style={{
                          margin: 0,
                          paddingRight: "40px",
                          width: "278px",
                          fontWeight: "500",
                          fontSize: "16px",
                          color: "#313233",
                          paddingLeft: "30px",
                        }}
                      >
                        {value.phone_number}
                      </td>

                      <td
                        colSpan={3}
                        style={{
                          width: "50px",
                          textAlign: "right",
                          paddingRight: "45px",
                        }}
                      >
                        <div className="cursor_pointer d-inline">
                          <img
                            onClick={(e) => this.editUser(value.user_id)}
                            style={{ textAlign: "right" }}
                            src={EditSvg}
                            alt="EditSvg"
                          ></img>
                        </div>
                      </td>
                    </tr>
                  ))
                )}

                {paginationLoading ? (
                  <tr>
                    <td colSpan="12" align="center">
                      <div class="d-flex justify-content-center">
                        <span
                          style={{ justifyContent: "center" }}
                          className="ml-3 spinner spinner-dark "
                        ></span>
                      </div>
                    </td>
                  </tr>
                ) : null}
                {error && !loading && users.length === 0 ? (
                  <tr>
                    <td colSpan="12" align="center">
                      <p
                        style={{
                          color: "red",
                          textAlign: "center",
                          verticalAlign: "middle",
                        }}
                      >
                        {error}
                      </p>
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
            {isEdit ? (
              <AddUserPage
                id="userAdd"
                style={{ margin: "0" }}
                is_edit={isEdit.toString()}
                facilities={facilities}
                edit_id={editId}
                show={modalShow}
                onHide={(value) => this.modalClose(value)}
              ></AddUserPage>
            ) : null}
          </div>
          {totalCount > RecordsperPage ? (
            <div
              style={{
                display: "flex",
                width: "100%",
                alignContent: "center",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              {loading
                ? Array.from({ length: 1 }, (_, index) => (
                    <Pagination
                      style={{
                        display: "flex",
                        flexWrap: "nowrap",
                      }}
                      onChange={this.handlePageChange}
                      count={totalPages}
                      siblingCount={0}
                      boundaryCount={1}
                      color="teal"
                      disabled
                      page={currentPage}
                      key={index + 1}
                      className={`pagination-button ${
                        currentPage === index + 1 ? "active" : ""
                      }`}
                    >
                      {index + 1}
                    </Pagination>
                  ))
                : Array.from({ length: 1 }, (_, index) => (
                    <Pagination
                      style={{
                        display: "flex",
                        flexWrap: "nowrap",
                      }}
                      onChange={this.handlePageChange}
                      count={totalPages}
                      siblingCount={0}
                      boundaryCount={1}
                      color="teal"
                      page={currentPage}
                      key={index + 1}
                      className={`pagination-button ${
                        currentPage === index + 1 ? "active" : ""
                      }`}
                    >
                      {index + 1}
                    </Pagination>
                  ))}
            </div>
          ) : (
            ""
          )}
          {deleteModalShow ? (
            <DeletePage
              show={deleteModalShow}
              headertxt={"Delete User"}
              deleteMsg={deleteMsg}
              toshowokbtn={toshowokbtn}
              haserror={deletePopupError}
              loading={deleteLoader}
              onHide={(opt) => this.deletemodalClose(opt)}
            ></DeletePage>
          ) : null}
        </div>
      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changeMenu: Actions.changeSideBar,
      FacilityName: Actions.FacilityName,
      facilityDetailsChange: Actions.changefacilityDetails,
      searchBarChange: Actions.changeSearchBar,
      monitorDetails: Actions.monitorDetails,
      refreshUsercount: Actions.refreshUsercount,
      handleDelete: Actions.handleDelete,
      UserListRefresh: Actions.UserListRefresh,
    },
    dispatch
  );
}
function mapStateToProps(state) {
  return {
    selectedMenu: state.selectedMenu,
    searchUser: state.searchUser,
    isSearchBar: state.isSearchBar,
    facilityDetails: state.facilityDetails,
    userManual: state.userManual,
    isDelete: state.isDelete,
    userListRefresh: state.userListRefresh,
  };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Users));
